export default [
  {
    path: "/zgq",
    name: "zgq",
    component: (resolve) => require(["@/views/PCView/zgq/index.vue"], resolve),
  },
];
